import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { MUSIC_OPTIONS, setSelectedTrack } from "../../store/ProductivitySessionSlice";
import "./ChangeBruit.css";
const ChangeBruit = ({ onClose }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { selectedTrack } = useSelector((state) => state.productivitySession);
    const { selectedSpeaker } = useSelector(state => state.mediaControls || {});

    const [previewTrackId, setPreviewTrackId] = useState(selectedTrack);

    const previewAudioRef = useRef(null);

    const currentPreviewData = MUSIC_OPTIONS.find(t => t.id === previewTrackId);

    useEffect(() => {
        if (!previewAudioRef.current) {
            previewAudioRef.current = new Audio();
            previewAudioRef.current.volume = 0.5;
            previewAudioRef.current.loop = true;
        }

        const audio = previewAudioRef.current;
        const deviceId = selectedSpeaker?.deviceId;

        const playPreview = async () => {
            if (!currentPreviewData) return;

            try {
                if (audio.src !== currentPreviewData.src) {
                    audio.src = currentPreviewData.src;
                    await audio.load();
                }

                if (deviceId && typeof audio.setSinkId === 'function') {
                    await audio.setSinkId(deviceId).catch(e => console.warn(e));
                }

                await audio.play();
            } catch (err) {
                console.warn("Preview Audio Error:", err);
            }
        };

        playPreview();

        return () => {
            audio.pause();
            audio.src = "";
        };
    }, [previewTrackId, selectedSpeaker?.deviceId, currentPreviewData]);

    const confirmChangeTrack = () => {
        dispatch(setSelectedTrack(previewTrackId));
        onClose();
    };
    const cancelChange = () => {
        onClose();
    };

    return (
        <>
            <div className="session-content-change-track">
                <div className="session-content-change-track-text">
                    <span className="session-subtitle">
                        {t("change_bruit_text")}
                    </span>
                    <div className="playing-track" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.625rem' }}>
                        <span className="material-symbols-outlined">volume_up</span>
                        <span className="playing-track-status">{t("in_progress")}:</span>
                        <span className="playing-track-name">{t(currentPreviewData?.name)}</span>
                    </div>
                </div>

                <div className="music-selection-section" style={{ marginTop: '1.25rem' }}>
                    <div className="music-grid">
                        {MUSIC_OPTIONS.map((track) => (
                            <button
                                key={track.id}
                                type="button"
                                className={`music-grid-btn ${previewTrackId === track.id ? 'active' : ''}`}
                                onClick={() => setPreviewTrackId(track.id)}
                            >
                                <div className="icon-wrapper" style={{ backgroundColor: track.back, padding: '0.5rem', borderRadius: '50%' }}>
                                    <span className="material-symbols-outlined" style={{ color: track.color }}>
                                        {track.icon}
                                    </span>
                                </div>
                                <span className="music-btn-label-change">{t(track.name)}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            <div className="session-button-container" style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem' }}>
                <button type="button" className="session-button-cancel" onClick={cancelChange}>
                    {t("cancel")}
                </button>
                <button type="button" className="session-button" onClick={confirmChangeTrack}>
                    {t("CONFIRM")}
                </button>
            </div>
        </>
    );
};

export default ChangeBruit;